@if (vm$ | async; as vm) {
  <app-header
    (menuClick)="drawer.toggle()"
    class="always-hide-on-print"
  ></app-header>

  <mat-drawer-container autosize>
    <mat-drawer #drawer mode="side" fullscreen>
      <app-navigation></app-navigation>
    </mat-drawer>

    <mat-drawer
      class="account-info-drawer-panel"
      position="end"
      mode="side"
      [opened]="showDrawer()"
      [style.width.px]="drawerWidthPx()"
    >
      @if (vm.firebaseUser && enablePlatformAccountSetter) {
        <app-account-info-drawer></app-account-info-drawer>
      }
    </mat-drawer>

    <mat-drawer-content id="matDrawerContent" class="mat-drawer-content">
      <!-- EXT-6537: the account bar, then the module tabs; both stay pinned as
           the page scrolls. EXT-6573: the account lookup sits at the right
           end of the account bar, with or without an account. -->
      @if (vm.firebaseUser && enablePlatformAccountSetter) {
        <app-account-banner class="always-hide-on-print">
          <app-account-setter class="always-hide-on-print"></app-account-setter>
        </app-account-banner>
      }
      <app-module-header
        jfwStickyStackTop=".account-topper"
      ></app-module-header>
      <div class="router-outlet">
        <router-outlet></router-outlet>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>

  @if (showDrawer()) {
    <div
      class="drawer-resize-handle"
      [style.right.px]="drawerWidthPx()"
      (mousedown)="startDrawerResize($event)"
    ></div>
  }

  @if (vm.firebaseUser && !vm.portalUser) {
    <spinner></spinner>
  }
} @else {
  <div class="app-loading">
    <img class="app-loading-logo" src="assets/images/logo.png" alt="JFW logo" />
    <img
      class="app-loading-logo dark"
      src="assets/images/logo-reverse.png"
      alt="JFW logo"
    />
    <span class="app-loading-wordmark">Platform<span> Portal</span></span>

    <div class="app-loading-progress">
      @for (step of loadingSteps; track step; let i = $index) {
        <span
          class="app-loading-segment"
          [class.done]="i < loadingStepIndex()"
          [class.active]="i === loadingStepIndex()"
        ></span>
      }
    </div>

    <span class="app-loading-label">{{ loadingLabel() }}</span>
  </div>
}
